// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-label-input-select-padrao {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: max-content;
}

.principais-input-select-padrao {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .2rem;
    margin-bottom: 0.2rem;
    position: relative;
}

.container-label-input-select-padrao svg {
    font-size: 1.3rem;
    color: var(--azul-dixi);
}

.container-label-input-select-padrao label {
    color: var(--cinza-label-input-padrao);
    font-size: .9rem;
    font-weight: bold;
    text-wrap: nowrap;
}

.container-obrigatorio-input-select-padrao {
    position: absolute;
    right: -7px;
    top: -2px;
}

.container-input-select-padrao {
    width: 100%;
    z-index: 1;
}

.select-padrao-container {
    position: relative;
    width: 100%;
}

.input-select-padrao-estilo {
    font-size: .9rem;
    height: 2.4rem;
    padding: .8rem 1.3rem;
    background-color: var(--cinza-fundo-input-padrao);
    border: 2px solid var(--border-color);
    border-radius: 5px;
    cursor: pointer;
    outline: none;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    color: var(--cinza-label-input-padrao);
}

.input-select-padrao-estilo:hover {
    outline: 2px solid var(--azul-dixi);
}

.input-select-padrao-estilo.open {
    width: 100%;
    color: var(--hover-text-color);
    outline: 2px solid var(--azul-dixi);
}

.input-select-padrao-estilo svg {
    font-size: 1.5rem;
}

.dropdown-options-container {
    position: absolute;
    width: 100%;
    margin: auto;
    background-color: var(--branco-padrao);
    box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.2);
    padding: .3rem .3rem .3rem .3rem;
    margin-top: 2px;
    display: flex;
    flex-direction: column;
    gap: .2rem;
}

.dropdown-options-container .dropdown-option {
    width: 100%;
    cursor: pointer;
    border-radius: 2px;
    padding: .4rem 1rem;
    transition: all .1s;
}

.dropdown-options-container .dropdown-option:hover {
    color: var(--branco-padrao);
    background-color: var(--azul-dixi);
}

.selecionado {
    color: var(--hover-text-color);
}

.erro-invalido {
    outline: 2px solid var(--error-color);
    border-radius: 5px;
}

.input-select-padrao-estilo.erro-invalido:hover {
    outline: 2px solid var(--error-color);
}

.close-icon-input-select {
    position: absolute;
    right: 3.5rem;
    cursor: pointer;
    transition: all .2s;
    z-index: 3000;
}

.close-icon-input-select:hover {
    color: var(--azul-dixi);
    transform: scale(1.1);
}`, "",{"version":3,"sources":["webpack://./src/components/InputSelectPadrao/InputSelectPadrao.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,iDAAiD;IACjD,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,+CAA+C;IAC/C,gCAAgC;IAChC,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB","sourcesContent":[".container-label-input-select-padrao {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    min-width: max-content;\n}\n\n.principais-input-select-padrao {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: .2rem;\n    margin-bottom: 0.2rem;\n    position: relative;\n}\n\n.container-label-input-select-padrao svg {\n    font-size: 1.3rem;\n    color: var(--azul-dixi);\n}\n\n.container-label-input-select-padrao label {\n    color: var(--cinza-label-input-padrao);\n    font-size: .9rem;\n    font-weight: bold;\n    text-wrap: nowrap;\n}\n\n.container-obrigatorio-input-select-padrao {\n    position: absolute;\n    right: -7px;\n    top: -2px;\n}\n\n.container-input-select-padrao {\n    width: 100%;\n    z-index: 1;\n}\n\n.select-padrao-container {\n    position: relative;\n    width: 100%;\n}\n\n.input-select-padrao-estilo {\n    font-size: .9rem;\n    height: 2.4rem;\n    padding: .8rem 1.3rem;\n    background-color: var(--cinza-fundo-input-padrao);\n    border: 2px solid var(--border-color);\n    border-radius: 5px;\n    cursor: pointer;\n    outline: none;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    color: var(--cinza-label-input-padrao);\n}\n\n.input-select-padrao-estilo:hover {\n    outline: 2px solid var(--azul-dixi);\n}\n\n.input-select-padrao-estilo.open {\n    width: 100%;\n    color: var(--hover-text-color);\n    outline: 2px solid var(--azul-dixi);\n}\n\n.input-select-padrao-estilo svg {\n    font-size: 1.5rem;\n}\n\n.dropdown-options-container {\n    position: absolute;\n    width: 100%;\n    margin: auto;\n    background-color: var(--branco-padrao);\n    box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.2);\n    padding: .3rem .3rem .3rem .3rem;\n    margin-top: 2px;\n    display: flex;\n    flex-direction: column;\n    gap: .2rem;\n}\n\n.dropdown-options-container .dropdown-option {\n    width: 100%;\n    cursor: pointer;\n    border-radius: 2px;\n    padding: .4rem 1rem;\n    transition: all .1s;\n}\n\n.dropdown-options-container .dropdown-option:hover {\n    color: var(--branco-padrao);\n    background-color: var(--azul-dixi);\n}\n\n.selecionado {\n    color: var(--hover-text-color);\n}\n\n.erro-invalido {\n    outline: 2px solid var(--error-color);\n    border-radius: 5px;\n}\n\n.input-select-padrao-estilo.erro-invalido:hover {\n    outline: 2px solid var(--error-color);\n}\n\n.close-icon-input-select {\n    position: absolute;\n    right: 3.5rem;\n    cursor: pointer;\n    transition: all .2s;\n    z-index: 3000;\n}\n\n.close-icon-input-select:hover {\n    color: var(--azul-dixi);\n    transform: scale(1.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
